// extracted by mini-css-extract-plugin
module.exports = {"check":"StrrdmResolveTableRow_check__1F5EE","times":"StrrdmResolveTableRow_times__2tIUZ"};